import React, { useState, useEffect } from 'react'
import TabbedContent from '../Global/TabbedContent'
import { Container, Row, Col, Button, Collapse } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

const FAQsPage = ({ faqData, pageContent, locale }) => {
  const [active, setActive] = useState(null)

  useEffect(() => {
    const setActiveAccordionNull = () => {
      setActive(null)
    }

    document.querySelectorAll('.nav-link').forEach((link) => {
      link.addEventListener('click', setActiveAccordionNull)
    })

    return () => {
      document.querySelectorAll('.nav-link').forEach((link) => {
        link.removeEventListener('click', setActiveAccordionNull)
      })
    }
  })

  return (
    <div className='faq-container'>
      <Container className='bg-header px-0' fluid>
        <Container>
          <Row className='justify-content-center'>
            <Col className='text-center col-12' md='10'>
              <h1>{pageContent?.title}</h1>
              <p
                className='h4 mt-3 mt-md-0'
                dangerouslySetInnerHTML={{ __html: pageContent?.bodyText1 }}
              ></p>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container className='bg-tabbed px-0' fluid>
        <Row>
          <Col>
            <TabbedContent
              className='mt-5 pt-3'
              theme='light'
              tabs={{
                titles: faqData?.map((e) => e.node.name)
              }}
            >
              {faqData.map((question, index) => {
                return (
                  <div key={index}>
                    {faqData[index].node.faq
                      ?.filter((faq) => faq.node.question)
                      .map((faq, index2) => {
                        return (
                          <Row key={index2}>
                            <Col md='12'>
                              <Button
                                onClick={() =>
                                  setActive(index2 == active ? null : index2)
                                }
                                aria-controls={`collapse-text-${index}-${index2}`}
                                aria-expanded={active == index2}
                                variant='light'
                                className='py-4 text-left w-100'
                              >
                                {faq.node.question}
                                <FontAwesomeIcon icon={faChevronDown} />
                              </Button>
                            </Col>
                            <Col md='12'>
                              <Collapse in={active == index2}>
                                <div id={`collapse-text-${index}-${index2}`}>
                                  <Container className='py-4'>
                                    <Row>
                                      <Col>
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              faq.node.richAnswer
                                                ?.childContentfulRichText.html
                                          }}
                                        ></p>
                                      </Col>
                                    </Row>
                                  </Container>
                                </div>
                              </Collapse>
                            </Col>
                          </Row>
                        )
                      })}
                  </div>
                )
              })}
            </TabbedContent>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default FAQsPage
